module.exports = "<button *ngIf='!assignTopicsOn'\n  (click)='switchAssignTopic()'>Assign topic</button>\n\n<div *ngIf='assignTopicsOn'>\n  <span *ngFor='let t of topicsList'\n    (click)='selectTopic(t)'\n    class='tag'>\n    {{t.title}}\n  </span>\n  <button (click)='switchAssignTopic()'>Close assignement</button>\n</div>\n\n<div class='assignedTopics'>\n    <app-assigned-topic-box *ngFor='let t of assignedTopics'\n    [project]='project'\n    [dbRecord]='dbRecord'\n    [topic]='t'\n    >\n    </app-assigned-topic-box>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/topic-selector/topic-selector.component.html
// module id = 448
// module chunks = 0